import { render, staticRenderFns } from "./DetailOrderWompiV2.vue?vue&type=template&id=54d5f424&scoped=true&"
import script from "./DetailOrderWompiV2.vue?vue&type=script&lang=js&"
export * from "./DetailOrderWompiV2.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderWompiV2.vue?vue&type=style&index=0&id=54d5f424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5f424",
  null
  
)

export default component.exports